import { z } from "zod";
/** An approximate place (a neighbourhood, never a door): what discovery and the request use. */
export const Place = z.object({ lat: z.number().min(-90).max(90), lon: z.number().min(-180).max(180) });
/** A locality's name, as a geocoder or the owner gives it ("Banashankari 2nd Stage"). */
export const LOCALITY_MAX = 60;
/** Two decimal places of a degree, about 1.1 km: the grid every point leaving a phone is rounded to (ADR 0045). */
const COARSE_SCALE = 100;
const coarse = (degrees) => Math.round(degrees * COARSE_SCALE) / COARSE_SCALE;
/** A point rounded to the coarse grid: a neighbourhood, never a building. */
export const coarsePoint = (p) => ({ lat: coarse(p.lat), lon: coarse(p.lon) });
//# sourceMappingURL=place.js.map